/**
 * GDPR Cookie Consent utilities
 * Stores consent in localStorage. No tracking scripts load before consent.
 */

export const CONSENT_STORAGE_KEY = 'numerolife_cookie_consent';

export interface CookieConsent {
  necessary: boolean;
  analytics: boolean;
  timestamp: number;
  version: number;
}

export const CONSENT_VERSION = 1;

export function getConsent(): CookieConsent | null {
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CookieConsent;
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function hasConsent(): boolean {
  const c = getConsent();
  return c !== null;
}

export function hasAnalyticsConsent(): boolean {
  const c = getConsent();
  return c !== null && c.analytics === true;
}

export function setConsent(necessary: boolean, analytics: boolean): void {
  const consent: CookieConsent = {
    necessary: true, // always true
    analytics,
    timestamp: Date.now(),
    version: CONSENT_VERSION,
  };
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent));
}

export function acceptAll(): void {
  setConsent(true, true);
}

export function rejectAll(): void {
  setConsent(true, false);
}

/** Dispatches event to open cookie preferences modal (e.g. from footer link) */
export const COOKIE_PREFERENCES_EVENT = 'numerolife:openCookiePreferences';

export function openCookiePreferences(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(COOKIE_PREFERENCES_EVENT));
  }
}
